/*
 * @Author: Kuiper
 * @Date: 2021-08-11 16:00:03
 */
import { CoocaaAccountInfo } from '/@/api/user/userModel'
export default {
  __set(state: any, msg: { key: string; val: any }) {
    state[msg.key] = msg.val
  },
  assign(state, account: CoocaaAccountInfo) {
    console.log('useAccountStore assign', account)
    state.userInfo = account
  },
  setLastTime(state, value: number) {
    state.lastTime = value
  },
  clear(state) {
    console.log('useAccountStore clear')
    state.userInfo = {
      code: 0,
      ak: null,
      uid: null,
      nickname: null,
      avatar: null,
      mobile: null,
      role: null,
    }
  },
}
